const absurd = (input: never): never => {
  throw new Error("absurd");
};
export default absurd;
